import React from "react";

import { Box, Text } from "@chakra-ui/react";
import { Dia } from "./Dia";
import { organizarDias } from "../../../utils/diaHorarioFilter";

export const Horarios = ({ horarios }) => {
  const horariosOrganizados =
    horarios?.length > 0 ? organizarDias(horarios) : [];
  return (
    <Box display="block" borderTop="1px solid #C4C4C4" bgColor="#FFF" p="8px">
      <Text
        fontWeight={700}
        fontSize="10px"
        lineHeight="21.6px"
        color="#797A80"
      >
        Horário de trabalho
      </Text>

      {horariosOrganizados?.domingo?.findIndex(
        (horario) => horario.start !== "" && horario.end !== ""
      ) === 0 && (
        <Dia nome="Domingo:" horarios={horariosOrganizados?.domingo} />
      )}

      {horariosOrganizados?.segunda?.findIndex(
        (horario) => horario.start !== "" && horario.end !== ""
      ) === 0 && (
        <Dia nome="Segunda-feira:" horarios={horariosOrganizados?.segunda} />
      )}
      {horariosOrganizados?.terca?.findIndex(
        (horario) => horario.start !== "" && horario.end !== ""
      ) === 0 && (
        <Dia nome="Terça-feira:" horarios={horariosOrganizados?.terca} />
      )}
      {horariosOrganizados?.quarta?.findIndex(
        (horario) => horario.start !== "" && horario.end !== ""
      ) === 0 && (
        <Dia nome="Quarta-feira:" horarios={horariosOrganizados?.quarta} />
      )}
      {horariosOrganizados?.quinta?.findIndex(
        (horario) => horario.start !== "" && horario.end !== ""
      ) === 0 && (
        <Dia nome="Quinta-feira:" horarios={horariosOrganizados?.quinta} />
      )}
      {horariosOrganizados?.sexta?.findIndex(
        (horario) => horario.start !== "" && horario.end !== ""
      ) === 0 && (
        <Dia nome="Sexta-feira:" horarios={horariosOrganizados?.sexta} />
      )}
      {horariosOrganizados?.sabado?.findIndex(
        (horario) => horario.start !== "" && horario.end !== ""
      ) === 0 && <Dia nome="Sábado:" horarios={horariosOrganizados?.sabado} />}
    </Box>
  );
};
